export default "/images/mail-footer.png?0e60ec495a00c491f37a0ad2838d57f9";